import { useNavigate } from "react-router"
import { FiHome, FiChevronLeft, FiChevronRight } from "react-icons/fi"

import Button from "react-bootstrap/Button"
import { UpdateIndicatorMobile } from "components"
import useT from "utils/hooks/useT"

// Main buttons on the mobile schedule screen.
export default function ScheduleButtonsMobile({ content, setToday: _setToday, goBackOneDay, goForwardOneDay }) {
  const navigate = useNavigate()
  const { t } = useT("common")

  return (
    <div className="ScheduleButtons-mobile">
      <div className="date-buttons-mobile">
        <Button title={t("nextDay")}  onClick={goBackOneDay}>
          <FiChevronLeft size="1.5rem" borderwidth={2}/>
        </Button>
        <Button title={t("previousDay")} onClick={goForwardOneDay}>
          <FiChevronRight size="1.5rem"/>
        </Button>
      </div>
      <div className="center-buttons">
        <h3 style={{fontSize: "1.5rem"}}>{content}</h3>
      </div>
      <div className="right-side-components">
        <UpdateIndicatorMobile/>
        <div className="member-week-buttons-mobile">
          <Button title={t("home")} onClick={() => navigate("/navigate")}>
            <FiHome size="1.3em" color="white" />
          </Button>
        </div>
      </div>
    </div>
  )
}
